import { getLoadSummary, getCarrierInfo } from '../../utils/api/load';
import {
  loadSummaryFetching,
  loadSummarySucceeded,
  loadSummaryFailed,
  updateLoadSummary,
} from './slice';
import { setAlert } from '../alerts/slice';
import ALERT_TYPES from '../alerts/constants';
import { setUpdatedLoad } from '../updated-load/slice';
import { getLoadFromSummary } from '../../utils/mappers';
import { logger } from '../../utils/common';

export const fetchLoadSummary = (loadId, salesOrderBk, loadOverrides = {}) => async (dispatch, getState) => {
  try {
    const { modeType: { type } } = getState();
    dispatch(loadSummaryFetching());
    const { data: { model: summary } } = await getLoadSummary(loadId, salesOrderBk, type);
    const selectedLoadId = getState().selectedLoad.id;
    if (selectedLoadId !== summary.loadId) {
      return;
    }
    const updatedLoadSummary = {
      ...summary,
      ...loadOverrides,
    };
    dispatch(loadSummarySucceeded(updatedLoadSummary));
    if (Object.keys(loadOverrides).length > 0) {
      dispatch(setUpdatedLoad(getLoadFromSummary(updatedLoadSummary)));
    }

    try {
      const { data: { model: secondaryInfo } } = await getCarrierInfo(summary.carrierId);
      if (getState().selectedLoad.id !== summary.loadId) {
        return;
      }
      dispatch(updateLoadSummary(secondaryInfo));
    } catch (error) {
      logger.error(error);
    }
  } catch (error) {
    if (error.status !== 404) {
      dispatch(setAlert({
        type: ALERT_TYPES.error,
        message: `Unable to get summary details for load #${salesOrderBk}`,
      }));
    }
    dispatch(loadSummaryFailed(error));
  }
};
